import React from "react";
import imagenLogo from "../image/Logo-softnik-positivo-color.png";
import AppVersion from "./AppVersion";
import "../css/portal-login.css";

/**
 * Cascarón de las pantallas de login. Lo comparten empleados, facturación,
 * sueldos, clientes, auditores, proveedores médicos y platform: cambian el
 * texto del hero y el formulario, no el diseño.
 *
 * Los estilos viven en css/portal-login.css. Ningún portal define colores
 * propios: la marca es una sola.
 *
 * @param {node}     claim        Frase del hero. Promesa con verbo ("Facturá,
 *                                cobrá y cerrá el mes"), no lista de funciones.
 * @param {string}   sub          Línea de apoyo debajo de la frase.
 * @param {node}     heroExtra    Pieza al pie del hero, si alguna pantalla la necesita.
 * @param {boolean}  longClaim    El claim es una frase, no el nombre de un portal:
 *                                baja el cuerpo para que entre sin comerse la ola.
 * @param {string}   title        Saludo grande del panel derecho.
 * @param {string}   subtitle     Línea debajo del saludo: identifica el portal.
 * @param {node}     children     El formulario.
 * @param {boolean}  employeeLink Muestra el link al login de empleados.
 * @param {node}     footer       Pie a medida, si hace falta otro que ese.
 */
const PortalLoginLayout = ({
    claim,
    sub,
    heroExtra = null,
    longClaim = false,
    title,
    subtitle,
    children,
    employeeLink = false,
    footer = null,
}) => (
    <div className={`login${longClaim ? " login--claim-long" : ""}`}>
        <div className="login-hero">
            <span className="login-hero-mark" aria-hidden="true" />

            <div className="login-hero-content">
                {claim && <h2 className="login-hero-claim">{claim}</h2>}
                {sub && <p className="login-hero-sub">{sub}</p>}

                {heroExtra}
            </div>
        </div>

        <div className="login-form-panel">
            <div className="login-card">
                <img src={imagenLogo} alt="Softnik" className="login-logo" />

                {title && <h1 className="login-title">{title}</h1>}
                {subtitle && <p className="login-subtitle">{subtitle}</p>}

                {children}

                {employeeLink && (
                    <a href="/" className="login-secondary-link">
                        Ir al login de empleados →
                    </a>
                )}

                {footer}
            </div>

            <p className="login-copyright">
                Copyright © 2026 Softnik. Todos los derechos reservados.
            </p>
            <AppVersion className="app-version--login" />
        </div>
    </div>
);

export default PortalLoginLayout;
